import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Icon, type IconName } from "./icon.tsx";
import "./button-v2.css";

export interface ButtonV2Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "small" | "normal" | "large";
  variant?: "neutral" | "danger" | "warning" | "outline" | "contrast" | "ghost" | "ghost-muted" | "loading";
  icon?: IconName;
  children?: ReactNode;
}

export function ButtonV2({
  size = "normal",
  variant = "neutral",
  icon,
  className,
  children,
  ...props
}: ButtonV2Props) {
  return (
    <button
      {...props}
      data-component="button-v2"
      data-size={size}
      data-variant={variant}
      data-icon={icon}
      className={className}
    >
      {icon ? <Icon name={icon} /> : null}
      {children}
    </button>
  );
}
